export default "__VITE_ASSET__OXcBF3vi__"